import { useState, useEffect } from "react";

import { Typography, Button } from "@mui/material";
import { Card, FormField } from "../";
import { isNil } from "lodash";

const CONNECTION_TYPE_OPTIONS = [
  { label: "WiFi", value: "wifi" },
  { label: "Ethernet", value: "ethernet" },
];

const IP_METHOD_OPTIONS = [
  { label: "DHCP", value: "dhcp" },
  { label: "Static", value: "static" },
];

const NetworkSettings = ({ networkSettings, onSelectNetwork, onSave }) => {
  const [formData, setFormData] = useState({
    connectionType: "",
    ssid: "",
    password: "",
    ipMethod: "",
  });

  useEffect(() => {
    if (!isNil(networkSettings)) {
      setFormData({
        ...formData,
        ...networkSettings,
      });
    }
  }, [networkSettings]);

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Card>
      <Typography variant="h6" align="center" mb={2}>
        Network Settings
      </Typography>
      <FormField
        showLabel={true}
        formFieldLabel="Connection Type"
        name="connectionType"
        type="radioboxgroup"
        value={formData.connectionType}
        variant="standard"
        onChange={onChange}
        options={CONNECTION_TYPE_OPTIONS}
      />
      <FormField
        showLabel={true}
        formFieldLabel="SSID"
        name="ssid"
        value={formData.ssid}
        variant="standard"
        onChange={onChange}
        autoComplete="off"
      />
      <FormField
        showLabel={true}
        formFieldLabel="Password"
        name="password"
        type="password"
        value={formData.password}
        variant="standard"
        onChange={onChange}
        autoComplete="off"
      />
      <FormField
        showLabel={true}
        formFieldLabel="IP Method"
        name="ipMethod"
        type="radioboxgroup"
        value={formData.ipMethod}
        variant="standard"
        onChange={onChange}
        options={IP_METHOD_OPTIONS}
      />

      <Button
        fullWidth
        variant="contained"
        onClick={() => onSelectNetwork(formData)}
        sx={{
          marginBottom: "12px",
        }}
      >
        Select Network
      </Button>
      <Button fullWidth onClick={() => onSave(formData)} variant="contained">
        Save
      </Button>
    </Card>
  );
};

export default NetworkSettings;
